import { observable } from 'mobx';

import { AnalyticsStore, ContextStore, SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';

import { bffFetchVacAuth, Headers } from 'sources/bff-fetch';

interface VacEvent {
  type: string;
}

export class VirtualAgentControlStore extends Store {
  private forwardedHeaders: Headers;

  @observable public javascriptUrl: string;
  @observable public initialized: boolean;
  private readonly host: string;

  public readonly VAC_WIDGET_OPENED_EVENT: string = 'VAC_WidgetOpened';
  public readonly VAC_WIDGET_OPENED_RFRR_ID: string = 'VA.FAB.Open';
  public readonly VAC_WIDGET_OPENED_DESCRIPTION: string = 'VAC Opened';

  public readonly VAC_WIDGET_CLOSED_EVENT: string = 'VAC_WidgetClosed';
  public readonly VAC_WIDGET_CLOSED_RFRR_ID: string = 'VA.FAB.Closed';
  public readonly VAC_WIDGET_CLOSED_DESCRIPTION: string = 'VAC Closed';

  constructor(forwardedHeaders: Headers = {}, state: SerializedData = {}, logger: Logger = NOOP_LOGGER, host: string = '') {
    super(state, logger);
    this.forwardedHeaders = forwardedHeaders;
    this.initialized = false;
    this.host = host;
  }

  public hydrate(data: SerializedData): void {
    // Since I'm not hydrating anything server side, I don't need this
  }

  public getVirtualAgentControl() {
    return window.c3WebChat;
  }

  public injectVirtualAgentControl(
    virtualAgentControl: VirtualAgentControl,
    analyticsStore: AnalyticsStore,
    context: ContextStore,
    pageName: string
  ) {
    if (virtualAgentControl && !this.initialized) {
      return bffFetchVacAuth(this.host, context, this.logger, this.forwardedHeaders)
        .then(result => {
          if (!this.initialized) {
            const subscribedEvents = [this.VAC_WIDGET_OPENED_EVENT, this.VAC_WIDGET_CLOSED_EVENT];
            const messengerSettings = {
              authToken: result.authToken,
              languageId: 'en_US',
              channelOriginId: result.channelOriginId,
              conversationProperties: {
                pageName,
                launchPoint: 'FAB'
              },
              subscribedEvents,
              eventHandler: event => this.eventHandler(analyticsStore, event)
            };

            return virtualAgentControl
              .initialize(messengerSettings)
              .then(() => {
                this.initialized = true;
              })
              .catch(err => {
                this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'VIRTUAL_AGENT_CONTROL_INITIALIZE_FAILURE'));
              });
          }
        })
        .catch(err => {
          this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'VIRTUAL_AGENT_CONTROL_BFF_FAILURE'));
        });
    } else {
      return new Promise(resolve => resolve());
    }
  }

  public eventHandler(analyticsStore: AnalyticsStore, event: VacEvent) {
    switch (event.type) {
      case this.VAC_WIDGET_OPENED_EVENT:
        analyticsStore.trackEvent(this.VAC_WIDGET_OPENED_RFRR_ID, this.VAC_WIDGET_OPENED_DESCRIPTION, analyticsStore.omnitureData);
        break;
      case this.VAC_WIDGET_CLOSED_EVENT:
        analyticsStore.trackEvent(this.VAC_WIDGET_CLOSED_RFRR_ID, this.VAC_WIDGET_CLOSED_DESCRIPTION, analyticsStore.omnitureData);
        break;
      default:
        break;
    }
  }

  public static DEFAULTS = {
    javascriptUrl: ''
  };
}
